import React from 'react';
import { NavLink } from 'react-router-dom';

class Navigation extends React.Component {

    componentDidMount() {
        function loadScript(src) {
            return new Promise(function (resolve, reject) {
                var script = document.createElement('script');
                script.src = src;
                script.addEventListener('load', function () {
                    resolve();
                });
                script.addEventListener('error', function (e) {
                    reject(e);
                });
                document.body.appendChild(script);
                document.body.removeChild(script);
            })
        };

        loadScript('./assets/js/masonary.js');
    };

    render() {
        const isActive = (path) => {
            return window.location.pathname === path;
        };

        return (
            <>
                <div className={(this.props.bgcolor !== '') ? `header-nav navbar-collapse collapse ${this.props.bgcolor}` : 'header-nav navbar-collapse collapse'}>
                    <ul className="nav navbar-nav" style={{ fontFamily: 'Cairo, sans-serif', fontSize: '30px' }}>
                        <li className={isActive('/contactus') ? 'active' : ''}>
                            <NavLink to={"/contactus"} end>تواصل معنا</NavLink>
                        </li>
                        <li className={isActive('/blog-grid') ? 'active' : ''}>
                            <NavLink to={"/blog-grid"}>بوابة الموردين</NavLink>
                        </li>
                        <li className={isActive('/project-grid') ? 'active' : ''}>
                            <NavLink to={"/project-grid"}>المشاريع</NavLink>
                        </li>
                        <li className={isActive('/Recrutement') ? 'active' : ''}>
                            <NavLink to={"/Recrutement"}>التوظيف</NavLink>
                        </li>
                        <li className={isActive('/services') ? 'active' : ''}>
                            <NavLink to={"/services"}>خدماتنا</NavLink>
                        </li>
                        <li className={isActive('/about') ? 'active' : ''}>
                            <NavLink to={"/about"}>عن الشركة</NavLink>
                        </li>
                        <li className={isActive('/') ? 'active' : ''}>
                            <NavLink to={"/"} end>الصفحة الرئيسية</NavLink>
                        </li>
                        
                    </ul>
                </div>
            </>
        );
    };
};

export default Navigation;